import { apiClient } from "@/lib/api/client"
import type {
  Issue,
  IssueAttachment,
  IssueDraftListItem,
  LineItemReferenceResult,
  OrderReferenceResult,
} from "../types/assistant.types"

// ─── Draft lifecycle ────────────────────────────────────────────────────

export async function getActiveDraft(): Promise<Issue | null> {
  const { data, status } = await apiClient.get<Issue>("/api/issues/drafts/active/")
  if (status === 204) return null
  return data
}

export async function listDrafts(): Promise<IssueDraftListItem[]> {
  const { data } = await apiClient.get<IssueDraftListItem[]>("/api/issues/drafts/")
  return data
}

export async function getIssue(id: number): Promise<Issue> {
  const { data } = await apiClient.get<Issue>(`/api/issues/${id}/`)
  return data
}

export async function submitDraft(id: number): Promise<Issue> {
  const { data } = await apiClient.post<Issue>(`/api/issues/${id}/submit/`)
  return data
}

export async function abandonDraft(id: number): Promise<void> {
  await apiClient.post(`/api/issues/${id}/abandon/`)
}

// ─── Upload ─────────────────────────────────────────────────────────────

export async function uploadAttachment(file: File): Promise<IssueAttachment> {
  const formData = new FormData()
  formData.append("file", file)
  const { data } = await apiClient.post<IssueAttachment>("/api/issues/upload/", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  })
  return data
}

// ─── Reference picker ────────────────────────────────────────────────────

export async function searchOrderReferences(
  q: string,
): Promise<OrderReferenceResult[]> {
  const { data } = await apiClient.get<OrderReferenceResult[]>(
    "/api/issues/references/orders/",
    { params: q ? { q } : {} },
  )
  return data
}

export async function listOrderLineItemReferences(
  orderId: number,
): Promise<LineItemReferenceResult[]> {
  const { data } = await apiClient.get<LineItemReferenceResult[]>(
    `/api/issues/references/orders/${orderId}/line-items/`,
  )
  return data
}
